<template>
  <div v-if="staffToolRoutes.length > 0" class="owal navigation menu dropdown container">
    <div class="owal navigation menu dropdown title">
      Settings
    </div>
    <div class="owal navigation menu content">
      <router-link
        v-for="route in staffToolRoutes"
        :key="route.path"
        class="owal navigation menu link"
        :to="route.path"
        @click.native="handleClick"
        >
        {{ route.name }}
      </router-link>
      <a v-if="canSeeStaffRoutes"
        class="owal navigation menu link"
        href="https://analytics.google.com/analytics/web/?authuser=1#/report-home/a113472089w171751985p171368221"
        >
        Google Analytics
      </a>
      <a
        v-if="canSeeStaffRoutes"
        class="owal navigation menu link"
        href="https://graf.p.owal.io/"
        >
        Grafana
      </a>
      <a
        v-if="canSeeStaffRoutes"
        class="owal navigation menu link"
        href="https://tagging.owal.io/"
        >
        Tagging Tool
      </a>
    </div>
    <git-info />
  </div>
</template>

<script>
import GitInfo from '@/components/shared/GitInfo'
import { mapGetters } from 'vuex'
import { Operation, Service } from '@/libraries/permissions'
import { routesForEntitlements, adminRoutesFromRoutes } from '@/libraries/nav/filters'

export default {
  name: 'StaffMenu',
  components: { GitInfo },
  computed: {
    ...mapGetters({
      canPerformOperationForService: 'entitlements/canPerformOperationForService',
      currentDomainEntitlements: 'entitlements/currentDomainEntitlements',
    }),
    canSeeStaffRoutes () {
      return this.canPerformOperationForService(Service.STAFF, Operation.VIEW_INTERNAL_LINKS)
    },
    staffToolRoutes () {
      const routes = this.$router.options.routes
      const entitlements = this.currentDomainEntitlements
      const candidateRoutes = adminRoutesFromRoutes(routes)
      const visibleRoutes = routesForEntitlements(candidateRoutes, entitlements)
      return visibleRoutes
    },
  },
  methods: {
    handleClick () {
      this.$emit('link-activated')
    },
  },
}
</script>

<style scoped>

@media only screen and (min-width: 961px) {
  .owal.navigation.menu.dropdown.container {
    color: #EFF2F7;
    display: flex;
    flex-direction: column;
    transition: all 0.2s ease-out;
    padding: 0;
    margin: 0;
  }

  .owal.navigation.menu.dropdown.title {
    display: flex;
    align-items: center;
    height: 44px;
    font-size: 1rem;
    font-weight: 400;
    margin: 0;
    font-family: 'Lato', 'Avenir', 'Helvetica', sans-serif;
  }

  .owal.navigation.menu.dropdown.container:hover {
    color: #C0CCDA;
    height: auto;
  }

  .owal.navigation.menu.dropdown.container .owal.navigation.menu.content {
    visibility: hidden;
    display: block;
    position: absolute;
    top: 44px;
    margin: 0;
    box-shadow: #222 0 10px 10px;
    border-top: 2px solid #C0CCDA;
    transition: inherit;
  }

  .owal.navigation.menu.dropdown.container:hover .owal.navigation.menu.content{
    display: flex;
    visibility: initial;
    flex-direction: column;
    width: 12rem;
    background: #324057;
    opacity: 1;
    height: auto;
  }

  .owal.navigation.menu.dropdown.container .owal.navigation.menu.content .owal.navigation.menu.link {
    color: #fff;
    transition: inherit;
    height: 44px;
    background: #324057;
    color: #C0CCDA;
    padding: 0.5rem .75rem;
    display: flex;
    align-items: center;
    margin: 0;
  }

  .owal.navigation.menu.dropdown.container .owal.navigation.menu.content .owal.navigation.menu.link:hover {
    background: #C0CCDA;
    color: #324057;
  }
}

@media only screen and (max-width: 960px) {

  /* Title */
  .owal.navigation.menu.dropdown.title {
    display: flex;
    flex-direction: column;
    justify-content: center;
    color: #C0CCDA;
    background: #677689;
    width: 100%;
    height: 2rem;
    padding-left: 1rem;
    font-family: Avenir-Black;
    font-size: 1rem;
  }

  /* Links */
  .owal.navigation.menu.link {
    display: flex;
    flex-direction: column;
    justify-content: center;
    background: #C0CCDA;
    color: #475669;
    width: 100%;
    height: 44px;
    padding-left: 1rem;
    font-family: Avenir-Black;
    font-size: 1.25rem;
  }

  .owal.navigation.menu.dropdown.container {
    border-bottom: 1px solid #677689;
  }
}
</style>
